export default __webpack_public_path__ + "static/media/Grandeur_large_7.c733212c.jpg";